import { connect } from 'react-redux'

import { doToggleLabelBatched } from 'actions/labels'

import { selectIsEditingTicketTitle } from 'selectors/app'
import { selectLabelsWithAppliedUpdates } from 'selectors/labelings'
import { selectCurrentTicketId } from 'selectors/tickets'

import LabelList from './view'

const select = state => ({
  isEditingTicketTitle: selectIsEditingTicketTitle(state),
  ticketId: selectCurrentTicketId(state),
  labels: selectLabelsWithAppliedUpdates(state),
})

const perform = {
  onDeleteClick: doToggleLabelBatched,
}

export default connect(select, perform)(LabelList)
